import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { StringListInput } from "../../fields/base/StringListInput";
import CustomTag from "./CustomTag";

const BulkTagsForm = ({
  filledTags,
  setFilledTags,
  selected,
  suggestedTags = /** @type {string[]} */ ([]),
  actionType = "add",
  taggedItemDescription = "",
}) => {
  const { t } = useTranslation(["tags"]);
  const count = selected?.length ?? 0;
  return (
    <Row className="pb-5">
      <form>
        <p className="pb-4 fs-4">
          {actionType === "remove" ?
            t(
              ($) =>
                $.tags.bulkTagsForm[
                  "Please enter the custom tags you would like to remove from the selected {description}s using the field below."
                ],
              { count, description: taggedItemDescription },
            )
          : t(
              ($) =>
                $.tags.bulkTagsForm[
                  "Please enter the custom tags you would like to add to the selected {description}s using the field below."
                ],
              { count, description: taggedItemDescription },
            )
          }
        </p>
        {suggestedTags?.filter((tag) => !filledTags.includes(tag) && tag)?.length ?
          <p
            className="d-flex justify-content-center align-items-center gap-3 flex-wrap px-5"
            style={{ fontSize: "15px" }}
          >
            {t(($) => $.tags.bulkTagsForm["Suggested Tags:"])}{" "}
            {suggestedTags
              ?.filter((tag) => !filledTags?.includes(tag) && tag)
              ?.map((tag) => (
                <CustomTag
                  onClick={() => setFilledTags([...filledTags, tag])}
                  tag={tag}
                  key={tag}
                  actionType={"add"}
                  showActionIcon={true}
                />
              ))}
          </p>
        : null}

        <Row className="pt-3 d-flex justify-content-center">
          <Col xs={12} md={6} className="px-5">
            <StringListInput
              value={filledTags ?? []}
              onChange={setFilledTags}
              placeholder={t(($) => $.tags.bulkTagsForm["Add {description} tags..."], {
                description: taggedItemDescription,
              })}
              aria-label={t(($) => $.tags.Tags)}
            />
          </Col>
        </Row>
      </form>
    </Row>
  );
};

export default BulkTagsForm;
